import { useMutation, useQueryClient } from '@tanstack/react-query';

type UpdateOrganizationParams = {
  id: number;
  name?: string;
  is_portal_login_enabled?: boolean;
};

export default function useUpdateAdminOrganization() {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement | undefined)
    ?.content;

  return useMutation({
    mutationFn: async (params: UpdateOrganizationParams) => {
      const response = await fetch(`/admin/api/organizations/${params.id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token || '',
        },
        body: JSON.stringify({
          name: params.name,
          is_portal_login_enabled: params.is_portal_login_enabled,
        }),
      });
      if (!response.ok) {
        throw new Error('クライアントの更新に失敗しました');
      }
      return await response.json();
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'organizations'] });
      queryClient.invalidateQueries({ queryKey: ['admin', 'organizations', variables.id] });
    },
  });
}
